import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainDocumentRoutingModule } from './main-document-routing.module';
import { MainDocumentComponent } from './main-document.component';



// OTHER MODULE IMPORTS

import { SharedModule } from './../../shared.module';
import { MaterialsModule } from './../../materials.module';

// IMPORT DOCUMENT MODULE COMPONENTS


import { DocumentsComponent } from '../documents.component';
import { LearnerProfileListComponent } from '../learner-profile-list/learner-profile-list.component';
import { LearnerProfileFormComponent } from '../learner-profile-list/learner-profile-form/learner-profile-form.component';
import { GroupProfileFormComponent } from '../group-profile-form/group-profile-form.component';
import { IndividualLearnerProfileComponent } from '../individual-learner-profile/individual-learner-profile.component';
import { IvAssessmentFormComponent } from '../iv-assessment-form/iv-assessment-form.component';
import { IvUnitListComponent } from '../iv-unit-list/iv-unit-list.component';
import { IvPlanFormComponent } from '../iv-plan-form/iv-plan-form.component';
import { DnaChecklistComponent } from '../medicals/dna-checklist/dna-checklist.component';
import { MedicalChecklistComponent } from '../medicals/medical-checklist/medical-checklist.component';



@NgModule({
  declarations: [
    MainDocumentComponent,
    DocumentsComponent,
    LearnerProfileListComponent,
    LearnerProfileFormComponent,
    GroupProfileFormComponent,
    IndividualLearnerProfileComponent,
    IvAssessmentFormComponent,
    IvUnitListComponent,
    IvPlanFormComponent,
    DnaChecklistComponent,
    MedicalChecklistComponent,
  ],
  imports: [
    CommonModule,
    MainDocumentRoutingModule,
    SharedModule,
    MaterialsModule,
  ],
  exports: [
    DocumentsComponent,
    LearnerProfileListComponent,
    LearnerProfileFormComponent,
    GroupProfileFormComponent,
    IndividualLearnerProfileComponent,
    IvAssessmentFormComponent,
    IvUnitListComponent,
    IvPlanFormComponent,
    DnaChecklistComponent,
    MedicalChecklistComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainDocumentModule { }
